import api from "./api";



export const createQuestion = async (payload) => {

    try {

        const response = await api.post(
            "/agent-certification-assessment/admin/questions",
            payload
        );

        if (
            (response.status === 200 ||
                response.status === 201) &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data,
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error creating question:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to create question",
        };

    }
};



export const fetchQuestions = async (
    assessmentId
) => {

    try {

        const response = await api.get(
            `/agent-certification-assessment/admin/assessments/${assessmentId}/questions`
        );

        if (
            response.status === 200 &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data || [],
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error fetching questions:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch questions",
        };

    }
};



export const updateQuestion = async (
    questionId,
    payload
) => {

    try {

        const response = await api.put(
            `/agent-certification-assessment/admin/questions/${questionId}`,
            payload
        );

        if (
            response.status === 200 &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data,
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error updating question:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to update question",
        };

    }
};



export const deleteQuestion = async (
    questionId
) => {

    try {

        const response = await api.delete(
            `/agent-certification-assessment/admin/questions/${questionId}`
        );

        if (
            response.status === 200 &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data,
                message:
                    response.data.message ||
                    "Question deleted successfully",
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error deleting question:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to delete question",
        };

    }
};